export default __webpack_public_path__ + "static/media/ctg-6a.531ac1c9.webp";